import { initialPrimeScheduleState } from "store/initialStates";
import { ReducersInterfaceAction } from "types/Reducers";
import { PrimeScheduleState } from "types/PrimeSchedule";
import { PrimeScheduleConstants } from "constants/constants";

export const primeScheduleReducer = (
  state = initialPrimeScheduleState,
  action: ReducersInterfaceAction,
): PrimeScheduleState => {
  switch (action.type) {
    case PrimeScheduleConstants.PRIME_SCHEDULE_TABLE_GET_DATA_SUCCESS:
      return {
        ...state,
        loadingData: false,
        ...action.payload,
      };
    case PrimeScheduleConstants.PRIME_SCHEDULE_GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        loadingData: false,
        userList: action.payload,
      };
    case PrimeScheduleConstants.PRIME_SCHEDULE_SET_FILTERS:
      return {
        ...state,
        primeScheduleFilters: action.payload,
      };
    default:
      return state;
  }
};
